import React from 'react';

import './index.scss';

const ContentSubmittedDate = ({date}) => {
    return (
        <div className="content-submitted-date">
            <span className="content-submitted-date__label">Submitted On:</span>
            <span>&nbsp;</span>
            <span className="content-submitted-date__value">{formatDate(date)}</span>
        </div>
    );
}

function formatDate(date) {
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12;
    const minutesStr = minutes < 10 ? `0${minutes}` : minutes;
    return `${month}/${day}/${year} ${hours12}:${minutesStr}${ampm}`;
}

export default ContentSubmittedDate;


// WEBPACK FOOTER //
// ./components/content_submitted_date/index.js